/** @ngInject */
export default function scratchSummaryController($scope, $state, $http) {

    $scope.toggleScratch = function () {
        $scope.expandScratch = !$scope.expandScratch
    };

    $scope.hideScratch = function () {
        $scope.expandScratch = false
    };

    $scope.openAccount = function (account) {
        $state.go("portfolio", {portfolioId: account.id})
    };

    $scope.deleteAccount = function (account) {
        $http.delete("/tradefloor/api/user/modelPortfolio/" + account.id)
             .then(function () {
                 $scope.$parent.refresh();
             })
    };

    $scope.accounts = [
        {"name": "Account 1", "todayPnL": -2700, "totalPnL": 300, "excess": 2000},
        {"name": "Awesome Trade", "todayPnL": 2700, "totalPnL": -300, "excess": -2090000},
        {"name": "Account 3", "todayPnL": 0, "totalPnL": 0, "excess": 0}
    ];

    $scope.sharedStrategy = ["Bob Peters", "Barry Newman", "Scarlett Briggs", "Peter Kowalski", "Ivan Malat"];

    $scope.addAccount = function () {

        $state.go("newAccount");

    };

    $scope.responsiveOptions =
        [
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: false
                }
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false
                }
            }
        ];
}